class TagCommander {
	constructor() {
		this.buttons = document.querySelectorAll(".tc-click a");
		this.forms = document.querySelectorAll(".wpcf7");

		if (this.buttons) {
			this.initPrivacyButton();
		}

		if (this.forms) {
			this.initFormTagCommanderEvents();
		}
	}

	initPrivacyButton() {
		this.buttons.forEach(button => {
			button.addEventListener("click", (e) => {
				e.preventDefault();
				tC.privacyCenter.showPrivacyCenter();
				return false;
			});
		});
	}

	reassignKeyInArray(array, index, newValue) {
		array[index] = newValue;
		return array;
	}

	initFormTagCommanderEvents() {
		this.forms.forEach(form => {
			form.addEventListener("wpcf7mailsent", (event) => {
				let inputs = event.detail.inputs;
				for (let i = 0; i < inputs.length; i++) {

					if (inputs[i].name === "your-lastname") {
						this.reassignKeyInArray(window.tc_vars, "user_nom", inputs[i].value);
					}

					if (inputs[i].name === "your-firstname") {
						this.reassignKeyInArray(window.tc_vars, "user_prenom", inputs[i].value);
					}

					if (inputs[i].name === "your-email") {
						this.reassignKeyInArray(window.tc_vars, "user_email", inputs[i].value);
					}

					if (inputs[i].name === "your-phone") {
						this.reassignKeyInArray(window.tc_vars, "user_telephone", inputs[i].value);
					}
				}

				this.reassignKeyInArray(window.tc_vars, "navigation_pagename", "contact_confirmation");
				this.reassignKeyInArray(window.tc_vars, "user_opt", {
					user_optin_general: "1",
					user_optin_sms: "1",
					user_optin_tel: "1",
					user_optin_email: "1",
					user_optin_courrier: "0",
					user_optin_partenaire: "0"
				});

				tC.container.reload({events: {pageview: [{}, {}]}});

			});
		});
	}
}
